import { Formik } from "formik";
import Cookies from 'js-cookie'
import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { LoginSchema } from '../../utils/Validation'
import { useDispatch } from "react-redux";
import { login } from "../../redux/lib/auth";
const LoginForm = () => {
  const Navigate = useNavigate();
  const dispatch = useDispatch()
  return (
    <>

      <div className="py-4 h-100 d-flex flex-column  justify-content-center align-items-center">
        <div className="w-100 text-center">

          <svg width="415" height="182" viewBox="0 0 415 182" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M163.1 78.5475C165.443 80.8907 165.443 84.6897 163.1 87.0328L120.529 129.604C118.186 131.947 114.387 131.947 112.044 129.604L85.2535 102.814C82.9103 100.471 82.9103 96.6718 85.2535 94.3286L127.825 51.7574C130.168 49.4142 133.967 49.4142 136.31 51.7574L163.1 78.5475Z" fill="#4A6DFF" />
            <path d="M130.432 78.5475C132.775 80.8907 132.775 84.6897 130.432 87.0328L87.8609 129.604C85.5178 131.947 81.7188 131.947 79.3756 129.604L52.5855 102.814C50.2423 100.471 50.2423 96.6718 52.5855 94.3286L95.1568 51.7574C97.4999 49.4142 101.299 49.4142 103.642 51.7574L130.432 78.5475Z" fill="#2EB9FF" />
            <path d="M210.078 93.6772C212.339 94.0988 214.198 95.2296 215.655 97.0694C217.111 98.9093 217.84 101.017 217.84 103.394C217.84 105.54 217.303 107.438 216.23 109.086C215.195 110.696 213.681 111.961 211.688 112.881C209.695 113.801 207.337 114.261 204.616 114.261H187.31V74.1287H203.868C206.59 74.1287 208.928 74.5695 210.883 75.4511C212.876 76.3327 214.371 77.5593 215.367 79.1308C216.402 80.7023 216.92 82.4847 216.92 84.4779C216.92 86.816 216.287 88.7709 215.022 90.3424C213.796 91.914 212.148 93.0256 210.078 93.6772ZM195.359 90.6874H202.718C204.635 90.6874 206.111 90.2658 207.146 89.4225C208.18 88.5409 208.698 87.2952 208.698 85.6853C208.698 84.0754 208.18 82.8297 207.146 81.9481C206.111 81.0665 204.635 80.6257 202.718 80.6257H195.359V90.6874ZM203.466 107.706C205.421 107.706 206.935 107.246 208.008 106.326C209.12 105.406 209.675 104.103 209.675 102.417C209.675 100.692 209.1 99.3501 207.95 98.3918C206.801 97.3952 205.248 96.8969 203.293 96.8969H195.359V107.706H203.466Z" fill="#1368A5" />
            <path d="M236.099 114.778C233.033 114.778 230.273 114.107 227.82 112.766C225.367 111.386 223.431 109.45 222.013 106.959C220.633 104.467 219.943 101.592 219.943 98.3343C219.943 95.0762 220.652 92.2015 222.07 89.71C223.527 87.2185 225.501 85.302 227.992 83.9604C230.484 82.5805 233.263 81.8906 236.329 81.8906C239.395 81.8906 242.174 82.5805 244.666 83.9604C247.157 85.302 249.112 87.2185 250.53 89.71C251.987 92.2015 252.715 95.0762 252.715 98.3343C252.715 101.592 251.968 104.467 250.473 106.959C249.016 109.45 247.023 111.386 244.493 112.766C242.002 114.107 239.204 114.778 236.099 114.778ZM236.099 107.764C237.556 107.764 238.916 107.419 240.181 106.729C241.484 106 242.519 104.927 243.286 103.509C244.053 102.091 244.436 100.366 244.436 98.3343C244.436 95.3062 243.631 92.9872 242.021 91.3774C240.45 89.7292 238.514 88.905 236.214 88.905C233.914 88.905 231.979 89.7292 230.407 91.3774C228.874 92.9872 228.107 95.3062 228.107 98.3343C228.107 101.362 228.855 103.701 230.35 105.349C231.883 106.959 233.799 107.764 236.099 107.764Z" fill="#1368A5" />
            <path d="M264.369 87.3527C265.404 85.6661 266.746 84.3437 268.394 83.3855C270.081 82.4272 271.997 81.9481 274.144 81.9481V90.3999H272.016C269.486 90.3999 267.57 90.9941 266.267 92.1823C265.002 93.3705 264.369 95.4404 264.369 98.3918V114.261H256.32V82.408H264.369V87.3527Z" fill="#1368A5" />
            <path d="M275.196 98.2193C275.196 94.9996 275.828 92.144 277.093 89.6525C278.396 87.161 280.159 85.2445 282.383 83.9029C284.606 82.5614 287.078 81.8906 289.799 81.8906C291.869 81.8906 293.843 82.3505 295.722 83.2705C297.6 84.1521 299.095 85.3403 300.206 86.8352V71.7139H308.371V114.261H300.206V109.546C299.21 111.118 297.811 112.382 296.009 113.341C294.207 114.299 292.118 114.778 289.742 114.778C287.059 114.778 284.606 114.088 282.383 112.708C280.159 111.328 278.396 109.393 277.093 106.901C275.828 104.371 275.196 101.477 275.196 98.2193ZM300.264 98.3343C300.264 96.3795 299.88 94.7121 299.114 93.3322C298.347 91.914 297.312 90.8407 296.009 90.1125C294.706 89.3458 293.307 88.9625 291.812 88.9625C290.317 88.9625 288.937 89.3267 287.672 90.055C286.407 90.7832 285.372 91.8565 284.567 93.2747C283.801 94.6546 283.417 96.3028 283.417 98.2193C283.417 100.136 283.801 101.822 284.567 103.279C285.372 104.697 286.407 105.79 287.672 106.556C288.975 107.323 290.355 107.706 291.812 107.706C293.307 107.706 294.706 107.342 296.009 106.614C297.312 105.847 298.347 104.774 299.114 103.394C299.88 101.976 300.264 100.289 300.264 98.3343Z" fill="#1368A5" />
            <path d="M343.543 97.6444C343.543 98.7943 343.466 99.8292 343.313 100.749H320.027C320.219 103.049 321.023 104.85 322.442 106.154C323.86 107.457 325.604 108.109 327.674 108.109C330.664 108.109 332.791 106.825 334.056 104.256H342.738C341.818 107.323 340.055 109.853 337.448 111.846C334.842 113.801 331.641 114.778 327.846 114.778C324.78 114.778 322.02 114.107 319.567 112.766C317.152 111.386 315.255 109.45 313.875 106.959C312.533 104.467 311.863 101.592 311.863 98.3343C311.863 95.0379 312.533 92.144 313.875 89.6525C315.216 87.161 317.095 85.2445 319.509 83.9029C321.924 82.5614 324.703 81.8906 327.846 81.8906C330.874 81.8906 333.577 82.5422 335.953 83.8454C338.368 85.1487 340.227 87.0077 341.53 89.4225C342.872 91.799 343.543 94.5396 343.543 97.6444ZM335.206 95.3446C335.167 93.2747 334.42 91.6265 332.963 90.3999C331.507 89.135 329.724 88.5026 327.616 88.5026C325.623 88.5026 323.937 89.1159 322.557 90.3424C321.215 91.5307 320.391 93.198 320.084 95.3446H335.206Z" fill="#1368A5" />
            <path d="M355.167 87.3527C356.202 85.6661 357.544 84.3437 359.192 83.3855C360.879 82.4272 362.795 81.9481 364.942 81.9481V90.3999H362.814C360.285 90.3999 358.368 90.9941 357.065 92.1823C355.8 93.3705 355.167 95.4404 355.167 98.3918V114.261H347.118V82.408H355.167V87.3527Z" fill="#1368A5" />
          </svg>
        </div>
        <h1 className="fw-bolder">Welcome !</h1>

        <Formik
          validationSchema={LoginSchema}
          onSubmit={({ mobile, password }) => {
            if (mobile === '01120223494' && password === '123456') {
              toast.success('Welcome to Border Dashboard')
              Cookies.set('user', JSON.stringify({isAuth:true, user:{ mobile: '01120223494', name: 'Ahmed Gabr' }}), { expires: 7 })

              dispatch(login({isAuth:true, user:{mobile: '01120223494', name:'Ahmed Gabr'}}))
              Navigate('/')

            } else {
              toast.error('Mobile number or password is not valid')
            }
          }}
          initialValues={{
            mobile: "01120223494",
            password: "123456",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form noValidate onSubmit={handleSubmit}>
              <Row className="mb-3 align-items-center justify-content-center gap-4 my-5">
                <Form.Group
                  as={Col}
                  md="8"
                  controlId="validationFormik101"
                  className="position-relative"
                >
                  <Form.Label>Mobile number</Form.Label>
                  <Form.Control
                    className="mb-1"
                    type="text"
                    name="mobile"
                    value={values.mobile}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.mobile && !errors.mobile}
                  />
                  {
                    errors.mobile && <span className="text-danger pt-1">{errors.mobile} </span>
                  }
                </Form.Group>
                <Form.Group
                  as={Col}
                  md="8"
                  controlId="validationFormik102"
                  className="position-relative"
                >
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    className="mb-1"
                    type="password"
                    name="password"
                    value={values.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.password && !errors.password}
                  />
                  {
                    errors.password && <span className="text-danger pt-1">{errors.password} </span>
                  }
                </Form.Group>
                <Col md='8' className="text-center">
                  <Button type="submit" >Log in</Button>
                </Col>
              </Row>


            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default LoginForm;